import React, { useEffect, useState } from 'react';
import { Lock, Clock } from 'lucide-react';
import api from '../utils/api';

/**
 * Market closed banner — shows when Forex/CFD markets are off (weekend).
 * Auto-refreshes every 5 min and shows countdown to next open.
 */
export default function MarketStatusBanner({ compact = false }) {
  const [status, setStatus] = useState(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let mounted = true;
    const fetchStatus = async () => {
      try {
        const r = await api.get('/market-status');
        if (mounted) setStatus(r.data);
      } catch {
        // silent
      }
    };
    fetchStatus();
    const intv = setInterval(fetchStatus, 5 * 60 * 1000);
    const tickInt = setInterval(() => setTick((t) => t + 1), 30 * 1000);
    return () => { mounted = false; clearInterval(intv); clearInterval(tickInt); };
  }, []);

  if (!status || status.is_open) return null;

  // Calculate countdown (use last fetched seconds_to_change minus drift)
  const secondsLeft = Math.max(0, (status.seconds_to_change || 0) - tick * 30);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor((secondsLeft % 3600) / 60);
  const countdown = hours > 0 ? `${hours} ساعة ${minutes} دقيقة` : `${minutes} دقيقة`;

  if (compact) {
    return (
      <div className="bg-amber-500/10 border border-amber-500/30 rounded-md px-2 py-1 text-[10px] text-amber-300 flex items-center gap-1.5" data-testid="market-closed-banner-compact">
        <Lock className="w-3 h-3 flex-shrink-0" />
        <span>السوق مغلق — يفتح خلال {countdown}</span>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-amber-500/10 to-orange-500/10 border border-amber-500/30 rounded-lg p-3 flex items-center gap-2.5 mb-3" data-testid="market-closed-banner">
      <Lock className="w-4 h-4 text-amber-400 flex-shrink-0" />
      <div className="flex-1">
        <div className="text-[12px] font-bold text-amber-300 mb-0.5">السوق مغلق — عطلة نهاية الأسبوع</div>
        <div className="text-[10px] text-zinc-400 flex items-center gap-1.5">
          <Clock className="w-3 h-3" />
          <span>يفتح بعد <span className="text-amber-300 font-mono font-bold">{countdown}</span></span>
          <span className="text-zinc-600">•</span>
          <span>الأسعار ثابتة منذ إغلاق الجمعة 22:00 UTC</span>
        </div>
      </div>
    </div>
  );
}
